import React, { Component } from 'react'
import { MDBContainer, MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBRow, MDBCol, MDBIcon  } from 'mdbreact';
import {  MDBTabPane, MDBTabContent, MDBNav, MDBNavItem, MDBNavLink } from "mdbreact";
import Axios from 'axios'
import { Steps, Alert  } from 'antd';
import { Chart } from "react-google-charts";

import adminfaculty from '../adminfaculty/adminfaculty';
import Modalarticletyps from './Modalarticletypes';




export default class superadmininside extends Component {

    constructor(props) {
        super(props);
        this.state = {
          articlesci1:[],
          articlehum1:[],
          articlesci2:[],
          articlehum2:[],
            article2:[],
            activeItem: "1"
        };
        // this.handleChange = this.handleChange.bind(this);
        // this.handleChange2 = this.handleChange2.bind(this);
         this.updateat = this.updateat.bind(this);
      }


      toggle = tab => e => {
        if (this.state.activeItem !== tab) {
          this.setState({
            activeItem: tab
          });
        }
      };


    componentDidMount() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
    
        }

        setTimeout(() => {
           //ภายใน
            Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectarticle1.php')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlesci1: res.data})
           }) 

           Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectarticlehum1.php')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlehum1: res.data})
           }) 

           //ภายนอก
           Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectarticle2.php')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlesci2: res.data})
           }) 

           Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectarticlehum2.php')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlehum2: res.data})
           }) 
         }, 0);



      }

      updateat(){
        setTimeout(() => {
           
          Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectarticle1.php')
         .then(res => {
           console.log(res);
         //  this.setState({ bankname: res.data, loading: false })
           this.setState({ article: res.data})
         }) 

         Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectarticle2.php')
         .then(res => {
           console.log(res);
         //  this.setState({ bankname: res.data, loading: false })
           this.setState({ article2: res.data})
         }) 


       }, 0);
      }



    render() {
        const { Step } = Steps;
        return (
            <MDBContainer >
            <div>
            <p className="text-right">สวัสดีคุณ : {localStorage.getItem('nameuser')}</p>
            <p className="text-right">การประชุมวิชาการ มหาวิทยาลัยราชภัฏกำแพงเพชร(ผู้ดูแลระบบกลาง)</p> 
         
               <MDBAlert color="success" >
                   <h2><MDBIcon far icon="chart-bar" /> สัดส่วนบทความ</h2>
                </MDBAlert>

                <MDBNav className="nav-tabs mt-5">
          <MDBNavItem>
            <MDBNavLink link to="#" active={this.state.activeItem === "1"} onClick={this.toggle("1")} role="tab" >
              ภายใน
            </MDBNavLink>
          </MDBNavItem>
          <MDBNavItem>
            <MDBNavLink link to="#" active={this.state.activeItem === "2"} onClick={this.toggle("2")} role="tab" >
              ภายนอก
            </MDBNavLink>
          </MDBNavItem>
          {/* <MDBNavItem>
            <MDBNavLink link to="#" active={this.state.activeItem === "3"} onClick={this.toggle("3")} role="tab" >
              Profile
            </MDBNavLink>
          </MDBNavItem> */}
        </MDBNav>

        <MDBTabContent activeItem={this.state.activeItem} >
          <MDBTabPane tabId="1" role="tabpanel">
            <br/>
        <Alert message={"บทความภายใน สาขาวิทยาศาสตร์และเทคโนโลยี จำนวน "+ this.state.articlesci1.length+" บทความ"} type="info" />
          <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเรื่อง</th>
                        <th>ผู้ลงทะเบียน</th>
                        <th>สาขา</th>
                        <th>ไฟล์บทความ</th>
                        <th>จัดการ</th>
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.articlesci1.map((articlesci1,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{articlesci1.send_name}  </td>
                        <td>{articlesci1.register_pname}{articlesci1.register_nameth} {articlesci1.register_lnameth}<br/>{articlesci1.register_phone}</td>
                        <td>{articlesci1.major_precent}</td>
                        <td><MDBBtn color="indigo" size="sm" href={articlesci1.send_uploadeword1}  target="_blank">WORD</MDBBtn> <MDBBtn color="pink" size="sm" href={articlesci1.send_uploadepdf1}  target="_blank">PDF</MDBBtn></td>
                    <td>   <Modalarticletyps  id_send={articlesci1.id_send} namearticla={articlesci1.send_name}  updateat={this.updateat} /></td>
                        </tr>
                      )}
                    </MDBTableBody>
           </MDBTable>

           <Alert message={"บทความภายใน สาขามนุษยศาสตร์และสังคมศาสตร์ จำนวน "+ this.state.articlehum1.length+" บทความ"} type="error" />
          <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเรื่อง</th>
                        <th>ผู้ลงทะเบียน</th>
                        <th>สาขา</th>
                        <th>ไฟล์บทความ</th>
                        <th>จัดการ</th>
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.articlehum1.map((articlehum1,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{articlehum1.send_name}</td>
                        <td>{articlehum1.register_pname}{articlehum1.register_nameth} {articlehum1.register_lnameth}<br/>{articlehum1.register_phone}</td>
                        <td>{articlehum1.major_precent}</td>
                        <td><MDBBtn color="indigo" size="sm" href={articlehum1.send_uploadeword1}  target="_blank">WORD</MDBBtn> <MDBBtn color="pink" size="sm" href={articlehum1.send_uploadepdf1}  target="_blank">PDF</MDBBtn></td>
                    <td>   <Modalarticletyps  id_send={articlehum1.id_send} namearticla={articlehum1.send_name}  updateat={this.updateat} /></td>
                        </tr>
                      )}
                    </MDBTableBody>
           </MDBTable>


          </MDBTabPane>
          <MDBTabPane tabId="2" role="tabpanel">
              <br/>
          <Alert message={"บทความภายนอก สาขาวิทยาศาสตร์และเทคโนโลยี จำนวน "+ this.state.articlesci2.length+" บทความ"} type="info" />
          <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเรื่อง</th>
                        <th>ผู้ลงทะเบียน</th>
                        <th>สาขา</th>
                        <th>ไฟล์บทความ</th>
                        <th>จัดการ</th>
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.articlesci2.map((articlesci2,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{articlesci2.send_name}</td>
                        <td>{articlesci2.register_pname}{articlesci2.register_nameth} {articlesci2.register_lnameth}<br/>{articlesci2.register_phone}</td>
                        <td>{articlesci2.major_precent}</td>
                        <td><MDBBtn color="indigo" size="sm" href={articlesci2.send_uploadeword1}  target="_blank">WORD</MDBBtn> <MDBBtn color="pink" size="sm" href={articlesci2.send_uploadepdf1}  target="_blank">PDF</MDBBtn></td>
                    <td>   <Modalarticletyps  id_send={articlesci2.id_send} namearticla={articlesci2.send_name}  updateat={this.updateat} /></td>
                        </tr>
                      )}
                    </MDBTableBody>
           </MDBTable>
           <Alert message={"บทความภายนอก สาขามนุษยศาสตร์และสังคมศาสตร์ จำนวน "+ this.state.articlehum2.length+" บทความ"} type="error" />
          <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเรื่อง</th>
                        <th>ผู้ลงทะเบียน</th>
                        <th>สาขา</th>
                        <th>ไฟล์บทความ</th>
                        <th>จัดการ</th>
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.articlehum2.map((articlehum2,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{articlehum2.send_name}</td>
                        <td>{articlehum2.register_pname}{articlehum2.register_nameth} {articlehum2.register_lnameth}<br/>{articlehum2.register_phone}</td>
                        <td>{articlehum2.major_precent}</td>
                        <td><MDBBtn color="indigo" size="sm" href={articlehum2.send_uploadeword1}  target="_blank">WORD</MDBBtn> <MDBBtn color="pink" size="sm" href={articlehum2.send_uploadepdf1}  target="_blank">PDF</MDBBtn></td>
                    <td>   <Modalarticletyps  id_send={articlehum2.id_send} namearticla={articlehum2.send_name}  updateat={this.updateat} />
                          
                    
                    </td>
                        </tr>
                      )}
                    </MDBTableBody>
           </MDBTable>
          </MDBTabPane>


      <MDBAlert color="info">
      <h3><MDBIcon far icon="chart-bar" /> สรุปจำนวนบทความ</h3> 
      </MDBAlert>
        <MDBRow>
            <MDBCol size="6">
            <MDBTable>
      <MDBTableHead>
        <tr>
          <th>#</th>
          <th>รายการ</th>
          <th>จำนวน</th>
        </tr>
      </MDBTableHead>
      <MDBTableBody>
        <tr>
          <td>1</td>
          <td>บทความภายใน</td>
          <td>{this.state.articlesci1.length + this.state.articlehum1.length }</td>
        </tr>
            <tr>
              <td></td>
              <td> - สาขาวิทยาศาสตร์และเทคโนโลยี</td>
              <td>{this.state.articlesci1.length}</td>
            </tr>
            <tr>
              <td></td>
              <td> - สาขามนุษยศาสตร์และสังคมศาสตร์</td>
              <td>{this.state.articlehum1.length}</td>
            </tr>
        <tr>
          <td>2</td>
          <td>บทความภายนอก</td>
          <td>{this.state.articlesci2.length + this.state.articlehum2.length}</td>
        </tr>
        <tr>
              <td></td>
              <td> - สาขาวิทยาศาสตร์และเทคโนโลยี</td>
              <td>{this.state.articlesci2.length}</td>
            </tr>
            <tr>
              <td></td>
              <td> - สาขามนุษยศาสตร์และสังคมศาสตร์</td>
              <td>{this.state.articlehum2.length}</td>
            </tr>
            <tr>
        <td></td>
          <td className="text-center" >รวม</td>
          <td>{(this.state.articlesci1.length + this.state.articlehum1.length) + (this.state.articlesci2.length + this.state.articlehum2.length) }</td>
        </tr>
      </MDBTableBody>
    </MDBTable>
            </MDBCol>
            <MDBCol size="6">
              
            <div className={"my-pretty-chart-container"}>
            <Chart
  width={'700px'}
  height={'400px'}
  chartType="PieChart"
  loader={<div>Loading Chart</div>}
  data={[
    ['Task', 'Hours per Day'],
    ['วิทยาศาสตร์และเทคโนโลยี(ภายใน)', this.state.articlesci1.length],
    ['มนุษยศาสตร์และสังคมศาสตร์(ภายใน)', this.state.articlehum1.length],
    ['วิทยาศาสตร์และเทคโนโลยี(ภายนอก)', this.state.articlesci2.length],
    ['มนุษยศาสตร์และสังคมศาสตร์(ภายนอก)', this.state.articlehum2.length],
  ]}
  options={{
    title: 'กราฟสรุปจำนวนบทความ',
    // Just add this option
    is3D: true,
  }}
  rootProps={{ 'data-testid': '2' }}
/>
      </div>
            </MDBCol>
       </MDBRow>

   
         
        </MDBTabContent>

  


            </div>
            </MDBContainer>
        )
    }
}
